let stepUpInFlight = null;
export function isPasskeyStepUpError(error) {
    return error.status === 428 && error.code === 'PASSKEY_STEP_UP_REQUIRED';
}
export async function performAutomaticPasskeyStepUp() {
    if (!stepUpInFlight) {
        stepUpInFlight = import('./passkeys')
            .then(({ passkeyApi }) => passkeyApi.authenticate('step_up'))
            .then(() => undefined)
            .finally(() => {
            stepUpInFlight = null;
        });
    }
    return stepUpInFlight;
}
